import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';

import { createPromotionsApiFetchers, PromotionsApiFetchersProvider, routes } from 'promotions';
import { AddPromotion, ListPromotions, PromotionDetails } from 'promotions/views';

import { useConstant } from 'hooks/useConstant';
import { selectSelectedProvider } from 'rdx/account';

import { useAppServices } from 'components/AppServicesProvider';

import { AppRoutes } from './AppRoutes';

const PromotionsEntryRedirect: React.FC = () => {
  return <Redirect to={AppRoutes.HOME} />;
};

export const PromotionsEntry = () => {
  const { apiClient } = useAppServices();
  const { fetchers } = useConstant(() => ({
    fetchers: createPromotionsApiFetchers(apiClient),
  }));
  const selectedProvider = useSelector(selectSelectedProvider);

  const isAbleToCreatePromotion =
    selectedProvider?.permissions.canCreatePromotions &&
    selectedProvider?.permissions.selfAssignCampaigns;

  if (!selectedProvider?.permissions.canSeePromotions) {
    return (
      <Route
        exact
        path={[routes.list, routes.addPromotion, routes.details.index]}
        component={PromotionsEntryRedirect}
      />
    );
  }

  return (
    <PromotionsApiFetchersProvider value={fetchers}>
      <Switch>
        <Route exact path={routes.list} component={ListPromotions} />
        {isAbleToCreatePromotion ? (
          <Route exact path={routes.addPromotion}>
            <AddPromotion />
          </Route>
        ) : (
          <Route exact path={routes.addPromotion} component={PromotionsEntryRedirect} />
        )}
        <Route exact path={routes.details.index} component={PromotionDetails} />
      </Switch>
    </PromotionsApiFetchersProvider>
  );
};
